import React, { useEffect } from "react";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { useState } from "react";
import {
  addFloor,
  deleteFloor,
  fetchAllFloors,
  restoreFloor,
  updateFloor,
} from "../../../api/floors";
import EditIcon from "@mui/icons-material/Edit";
import { fetchActiveAreas } from "../../../api/areas";
import { fetchEntityLocation } from "../../../api/locations";
import toast from "react-hot-toast";

const INITIAL_DETAILS = {
  name: "",
  description: "",
  key: "",
  areaId: "",
};

export function useFloorMaster() {
  const [floorData, setFloorData] = useState([]);

  const [formValues, setFormValues] = useState(INITIAL_DETAILS);

  const [locations, setLocation] = useState([]);
  const [areas, setAreas] = useState([]);

  const [open, setOpen] = useState(false);
  const [searchValue, setSearchvalue] = useState("");
  const [buttonHandle, setButtonHandle] = useState("");
  const [searchArea, setSearchArea] = useState("");

  let tenantId = localStorage.getItem("tenantId");
  const locationId = localStorage.getItem("locationId");

  const isDisabled =
    !formValues?.name || !formValues?.description || !formValues?.areaId;

  const getAllFloors = async () => {
    let response = await fetchAllFloors(locationId, tenantId);
    setFloorData(response);
  };

  const handleChange = (event) => {
    setFormValues({ ...formValues, [event.target.name]: event.target.value });
  };

  const handleClickOpen = () => {
    setOpen(true);
    setButtonHandle("Add");
    handleClear();
  };

  const handleClose = () => {
    setOpen(false);
    handleClear();
  };

  const handleSearchChange = (e) => {
    setSearchvalue(e.target.value);
  };

  const handleEdit = (row) => {
    console.log(row);
    setFormValues(row);
    setOpen(true);
    setButtonHandle("Edit");
  };

  const getActiveAreas = async () => {
    let response = await fetchActiveAreas(locationId, tenantId);
    if (response) setAreas(response);
    return response;
  };

  // const getEntityLocations = async () => {
  //   let response = await fetchEntityLocation(tenantId);
  //   setLocation(response);
  //   return response;
  // };

  const handleSubmit = async () => {
    let data = {
        name: formValues.name,
        description: formValues.description,
        locationId: locationId,
        areaId: formValues.areaId,
      },
      response;
    if (!formValues?.key) {
      response = await addFloor(locationId, tenantId, data);
    } else {
      data.id = formValues.key;
      response = await updateFloor(locationId, tenantId, data);
    }
    if (response && !!response.id) {
      getAllFloors();
      toast.success(
        `Floor ${formValues.key ? "updated" : "saved"} successfully`
      );
      setOpen(false);
    } else if (response.id === null) {
      toast.error("Floor already exists");
    } else {
      toast.error("Failed to save floor");
    }
  };

  const deleteFloorDetails = async (id) => {
    let response = await deleteFloor(id, locationId, tenantId);
    if (response) {
      getAllFloors();
    }
  };

  const restoreBlockDetails = async (id) => {
    let response = await restoreFloor(id, locationId, tenantId);
    if (response) {
      getAllFloors();
    }
  };

  const handleClear = () => {
    setFormValues({
      name: "",
      description: "",
    });
  };

  const filteredRows = floorData?.filter(
    (row) =>
      row.name.toLowerCase().includes(searchValue.toLowerCase()) ||
      row.description.toLowerCase().includes(searchValue.toLowerCase())
  );

  const columns = [
    {
      field: "id",
      headerName: "NO",
      headerClassName: "super-app-theme--header",
      flex: 1,
    },
    {
      field: "name",
      headerName: "NAME",
      headerClassName: "super-app-theme--header",
      flex: 1,
    },

    {
      field: "description",
      headerName: "DESCRIPTION",
      headerClassName: "super-app-theme--header",
      flex: 1,
    },
    {
      field: "active",
      headerName: "STATUS",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <Box display={"flex"} paddingRight={1}>
          {params?.row?.deleted === false ? (
            <Button
              variant="contained"
              size="small"
              color="success"
              sx={{ width: "2rem" }}
              onClick={() => deleteFloorDetails(params?.row?.key)}
            >
              <Typography sx={{ fontSize: "10px" }}>Active</Typography>
            </Button>
          ) : (
            <Button
              variant="contained"
              size="small"
              color="error"
              sx={{ width: "2rem" }}
              onClick={() => restoreBlockDetails(params?.row?.key)}
            >
              <Typography sx={{ fontSize: "10px" }}>Inactive</Typography>
            </Button>
          )}
        </Box>
      ),
    },
    {
      field: "action",
      headerName: "ACTION",
      headerClassName: "super-app-theme--header",
      flex: 1,
      renderCell: (params) => (
        <Box display="flex" justifyContent="center">
          <IconButton onClick={() => handleEdit(params.row)}>
            <EditIcon />
          </IconButton>
        </Box>
      ),
    },
  ];

  const rows =
    filteredRows?.length === 0 || filteredRows?.length === undefined
      ? []
      : filteredRows?.map((rowData, index) => ({
          key: rowData.id,
          id: index + 1,
          name: rowData.name,
          description: rowData.description,
          status: rowData.status,
          deleted: rowData.deleted,
          areaId: rowData.areaId,
        }));

  useEffect(() => {
    getAllFloors();
  }, [searchArea]);

  useEffect(() => {
    // getEntityLocations();
    getActiveAreas();
  }, []);

  return {
    open,
    rows,
    areas,
    columns,
    locations,
    formValues,
    searchValue,
    buttonHandle,
    isDisabled,
    searchArea,
    setSearchArea,
    handleChange,
    handleClickOpen,
    handleClose,
    handleSearchChange,
    handleSubmit,
    handleClear,
  };
}
